import Vue from 'vue'


export function notification(icon, title, timer) {
  Vue.swal({
    icon: icon,
    title: title,
    showConfirmButton: false,
    timer: timer,
  })
  // Vue.swal({
  //   position: 'top-end',
  //   icon: icon,
  //   title: title,
  //   showConfirmButton: false,
  //   timer: timer,
  // })
}

export function notificationConfirm(icon, title) {
  Vue.swal({
    icon: icon,
    title: title,
    showConfirmButton: true,
    confirmButtonText: 'Ok',
  })
}

export function notificationAck(icon, title, msg) {
  Vue.swal.fire({
    title: title,
    html: msg,
    icon: icon,
    showCancelButton: false,
    confirmButtonText: 'Ok',
  })
}

export async function confirmAlertDisplay(title, msg) {
  let response = false
  await Vue.swal.fire({
    title: title,
    html: msg,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#34c38f',
    cancelButtonColor: '#f46a6a',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
  }).then(result => {
    if (result.isConfirmed) {
      response = true
    } else {
      response = false
    }
  })
  return response
}
